import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from './locals/en.json'
import translationFR from './locals/ca.json'

const resources = {
  en: {
    translation: translationEN,
  },
  ca: {
    translation: translationFR,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
